var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-placeholder",attrs:{"aria-hidden":"true"}},[_c('AppButtonTextWithIcon',{attrs:{"text":_vm.largestOptionText,"size":_vm.size,"icon":_vm.icon,"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }